// extracted by mini-css-extract-plugin
export var arrow = "_p-4";
export var arrowButton = "_p-6";
export var columnResizer = "_p-a";
export var columnResizerActive = "_p-c";
export var columnResizerIndicator = "_p-d";
export var columnResizerIndicatorActive = "_p-e";
export var columnResizerVisible = "_p-b";
export var headerCell = "_p-0";
export var help = "_p-3";
export var hoverArrow = "_p-5";
export var icon = "_p-2";
export var iconButton = "_p-9";
export var iconWrapper = "_p-8";
export var noBorder = "_p-f";
export var sortableHeaderCell = "_p-1";
export var textButton = "_p-7";